import { Paths } from '@constants/Navigation/AppPaths';
import React from 'react';
import { Breadcrumb } from 'routing/components/Breadcrumb';
import { RoutePathDefinition } from 'routing/routes';

const HouseKeepingReportPage = React.lazy(() => import('../pages/HouseKeepingReportPage'));
const RoomServiceStatusPage = React.lazy(() => import('../pages/RoomServiceStatusPage'));
const WorkManagementPage = React.lazy(() => import('../pages/WorkManagementPage'));

const HouseKeepingRoutes: RoutePathDefinition[] = [
  {
    path: Paths.HOUSE_KEEPING_REPORT_PATH,
    element: (
      <React.Suspense fallback={<>...</>}>
        <HouseKeepingReportPage />
      </React.Suspense>
    ),
    handle: {
      crumb: () => <Breadcrumb label="House Keeping Report" path={null} />,
    },
  },
  {
    path: Paths.HOUSE_KEEPING_ROOM_SERVICE_STATUS_PATH,
    element: (
      <React.Suspense fallback={<>...</>}>
        <RoomServiceStatusPage />
      </React.Suspense>
    ),
    handle: {
      crumb: () => <Breadcrumb label="Room Service Status" path={null} />,
    },
  },
  {
    path: Paths.HOUSE_KEEPING_WORK_MANAGEMENT_PATH,
    element: (
      <React.Suspense fallback={<>...</>}>
        <WorkManagementPage />
      </React.Suspense>
    ),
    handle: {
      crumb: () => <Breadcrumb label="Work Management" path={null} />,
    },
  },
];

export default HouseKeepingRoutes;
